import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { uploadFile } from "../api/fetchFile";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";

export interface UploadFileParams {
  file: File;
  endpoint: string;
  token?: string;
}

export const useUploadFile = (): UseMutationResult<ApiResponse<any>, ApiError, UploadFileParams> => {
  return useMutation({
    mutationFn: ({ file, endpoint, token }) => uploadFile(file, endpoint, token),
    onError: (error) => {
      console.error("File upload error:", error);
    }
  });
};
